/** @format */
import { loadSisCommonTranslations } from 'sis-common';
import { loadSisComponentsTranslations } from 'sis-components/translate/translation-loader.ts';
import { loadStudentTranslations } from './student-translate-loader.ts';
(function () {
  angular.module('app.common.translations', []).factory('appTranslationsAsync', () => language => [loadSisCommonTranslations(language), loadSisComponentsTranslations(language), loadStudentTranslations(language)]);
})();